var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg-vlight-paper shadow overflow-hidden sm:rounded-md"},[_c('ul',_vm._l((_vm.topics),function(topic,idx){return _c('li',{key:idx,class:{ 'border-t border-green': idx > 0 }},[_c('topic-table-row',{attrs:{"topic":topic}})],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }